import { SET_LOCATION_DATA } from '../location/redux/actions'
import * as actions from './redux/actions'

/**
 * Watcher to close the modal if the location changes.
 * i.e. clicking a link from the modal.
 */
export default function onPageChangeWatcher ({ before }) {
  return before(SET_LOCATION_DATA, async ({ state, dispatch }) => {
    const { modal } = state
    if (modal.get('isOpen') > 0) {
      dispatch(actions.removeModal())
    }
  })
}
